import { Typography } from '@mui/material'
import PhoneNumber from 'awesome-phonenumber'

interface PhoneViewProps {
  phone?: string | number
}

const PhoneView = ({ phone }: PhoneViewProps) => {
  const internationalPhone = new PhoneNumber(
    phone?.toString() ?? '',
    'dk',
  ).getNumber('international')
  return (
    <Typography style={{ width: '100%', fontSize: 14 }}>
      {internationalPhone}
    </Typography>
  )
}

export default PhoneView
